import apiClient from './api';

export const therapistService = {
  getAll: async () => {
    const res = await apiClient.get('/Therapists');
    return res.data;
  },
  create: async (payload) => {
    const res = await apiClient.post('/Therapists', payload);
    return res.data;
  },
  getById: async (id) => {
    const res = await apiClient.get(`/Therapists/${id}`);
    return res.data;
  },
  update: async (id, payload) => {
    const res = await apiClient.put(`/Therapists/${id}`, payload);
    return res.data;
  },
  remove: async (id) => {
    const res = await apiClient.delete(`/Therapists/${id}`);
    return res.data;
  },
  getByUser: async (userId) => {
    const res = await apiClient.get(`/Therapists/user/${userId}`);
    return res.data;
  },
  getVerified: async () => {
    const res = await apiClient.get('/Therapists/verified');
    return res.data;
  },
  getAcceptingClients: async () => {
    const res = await apiClient.get('/Therapists/accepting-clients');
    return res.data;
  }
};
